
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3 19.7324V22H5V19.7324C5.5978 19.3866 6 18.7403 6 18C6 17.2597 5.5978 16.6134 5 16.2676V2H3V16.2676C2.4022 16.6134 2 17.2597 2 18C2 18.7403 2.4022 19.3866 3 19.7324ZM11 13.7324V17.5V22H12.8096C11.6888 20.8321 11 19.2465 11 17.5C11 15.1988 12.1958 13.177 13.9999 12.0219L14 12C14 11.2597 13.5978 10.6134 13 10.2676V2H11V10.2676C10.4022 10.6134 10 11.2597 10 12C10 12.7403 10.4022 13.3866 11 13.7324ZM21 7.73244V12.0218C20.3945 11.6341 19.7204 11.3441 19 11.1739V7.73244C18.4022 7.38663 18 6.74028 18 6C18 5.25972 18.4022 4.61337 19 4.26756V2H21V4.26756C21.5978 4.61337 22 5.25972 22 6C22 6.74028 21.5978 7.38663 21 7.73244ZM14.9177 17.4327C14.9177 15.9511 16.1188 14.75 17.6004 14.75C19.082 14.75 20.2831 15.9511 20.2831 17.4327C20.2831 18.1226 20.0237 18.7501 19.5959 19.2259C19.1037 19.7731 18.3926 20.1155 17.6004 20.1155C16.1188 20.1155 14.9177 18.9144 14.9177 17.4327ZM17.6004 13.25C15.2903 13.25 13.4177 15.1227 13.4177 17.4327C13.4177 19.7428 15.2903 21.6155 17.6004 21.6155C18.5508 21.6155 19.4276 21.2979 20.1297 20.7642L21.8958 22.5303L22.9565 21.4697L21.1434 19.6566C21.5485 19.0124 21.7831 18.2495 21.7831 17.4327C21.7831 15.1227 19.9105 13.25 17.6004 13.25Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowParameterQueryFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
